
export default {

    props: {

        // The source of the image to display
        src: {
            type: [String, Object],
            required: true
        },

        // The dimension data of the image it will be displayed
        size: {
            type: Object,
            required: true
        },

        // The max width of the image that can be requested. Relevant for devices with a high device pixel ratio.
        maxWidth: {
            type: Number,
            default: 1920
        },

        // Whether to scale the image as large as possible to fill the container, stretching the image if necessary.
        // If the proportions of the image differ from the element, it is cropped either vertically or horizontally so that no empty space remains.
        cover: {
            type: Boolean,
            default: false
        },

        // Whether to immediate load the image when the component is loaded even when it's not visible.
        // This triggers the image to be loaded on server side without optimized aspect ratio as we can not detect the real device's screen size on ssr,
        // but it might be useful to optimize the page for LCP.
        immediate: {
            type: Boolean,
            default: false
        },

        // The blur density to add to the image style
        blur: {
            type: Number,
            default: null
        },

        // The alt text of the image
        alt: {
            type: String,
            default: null,
        }
    },


};

